(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    // The drawer dialog is 100dvh below 750px and everything inside it is overflow:hidden, and dvh does
  // not shrink when the on-screen keyboard opens (Chrome's default interactive-widget=resizes-visual).
  // So on a phone, tapping the discount field can leave Apply, the error line and Check out behind the
  // keyboard with nothing able to scroll. Track the visual viewport while the drawer is open and clamp
  // the dialog to it. Inert unless a keyboard is actually up: with no keyboard the branch never runs.
  (() => {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const KEYBOARD_MIN = 100;

    const clamp = () => {
      const dialog = document.querySelector('cart-drawer-component dialog[open]');
      if (!dialog) return;
      const covered = window.innerHeight - viewport.height;
      if (window.innerWidth > 749 || covered < KEYBOARD_MIN) {
        dialog.style.removeProperty('height');
        dialog.style.removeProperty('top');
        return;
      }
      dialog.style.height = `${Math.round(viewport.height)}px`;
      dialog.style.top = `${Math.round(viewport.offsetTop)}px`;
    };

    viewport.addEventListener('resize', clamp);
    viewport.addEventListener('scroll', clamp);
    document.addEventListener('focusin', () => window.setTimeout(clamp, 250));
    document.addEventListener('focusout', () => window.setTimeout(clamp, 250));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dz-cart-return-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    // The order-summary link carries ?dz=edit-items, which survives a stripped referrer; the cart
    // icon in the checkout header carries nothing, so that route is recognised by its referrer.
    try {
      if (new URLSearchParams(window.location.search).get('dz') === 'edit-items') {
        document.documentElement.setAttribute('data-dz-from-checkout', '');
        return;
      }
    } catch {}
    try {
      const referrer = new URL(document.referrer);
      if (referrer.origin === window.location.origin && /\/checkouts?\//.test(referrer.pathname)) {
        document.documentElement.setAttribute('data-dz-from-checkout', '');
      }
    } catch {}
  })();
  } catch(e) { console.error(e); }
})();

})();
